import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

function getUserLanguage() {
  let lang = '';
  if (sessionStorage.getItem("language")) {
    lang = sessionStorage.getItem("language");
  } else {
    const navLang = navigator.language || navigator.userLanguage;
    lang = navLang.substring(0, 2);
  }
  return lang;
}

export default new VueI18n({
  locale: getUserLanguage() || 'nl',
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
})
